import { SystemStyleObject } from '@chakra-ui/react';
import {
  getBoxSizingStyles,
  getTypographyToken,
} from '@allergan-data-labs/alle-elements-core';

export const getActionHeaderStyles = (): SystemStyleObject => {
  return {
    ...getBoxSizingStyles(),
    ...getTypographyToken('Headline/Extra small/Primary medium'),
    padding: '8',
  };
};
